<template>
  <div class="popup_content" style="overflow: visible !important">
    <v-popuptitle :message="title" imgsrc="sub/ic_b_enroll.png"></v-popuptitle>
    <!-- .popup__con_inner 공통 클래스 .bg__form_ver (입력폼에만 bg컬러 추가) -->
    <div class="popup__con_inner" style="overflow: visible !important">
      <div class="board__box mt10">
        <table class="comm__table" style="padding: 10px">
          <colgroup>
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th><p class="commp fwb">이름</p></th>
              <th>
                <p class="commp fwb">{{ dataObject.studentName }}</p>
              </th>
              <th><p class="commp fwb">학년/반/번호</p></th>
              <th>
                <p class="commp fwb">{{ `${dataObject.studentToSchoolGrade1}학년 ${dataObject.studentToSchoolGrade2}반 ${dataObject.studentToSchoolGrade3}번` }}</p>
              </th>
            </tr>
            <tr>
              <th
                ><p class="commp fwb">{{ title }}</p></th
              >

              <td colspan="3" style="padding: 10px; height: 80px">
                <div class="comm_radio" style="margin-left: 6px">
                  <div class="radio-group mt5 mb10">
                    <label v-for="(option, index) in options" :key="index" class="radio_box d_inblock hei100" :class="{ ml20: option.id !== 'C009000001' }">
                      <input type="radio" :value="option.label" :id="option.id" :checked="checked(option.label, selectedOption)" class="blind" v-model="selectedOption" />
                      <label :for="option.id">
                        <span class="icon"></span>
                        <span class="label_t commp c_black" style="margin: 0; padding-left: 5px">{{ option.label }}</span>
                      </label>
                    </label>
                  </div>
                </div>
                <div v-if="selectedOption === '개별 검진'" class="flex_set mt10 ml5 mb5" style="text-align: left">
                  <div class="flex_item">
                    <p class="scommp c_gray2 fwn" style="margin-bottom: 6px">
                      검진기관명
                      <span class="c_red">*</span>
                    </p>
                    <div class="m__putbox mt5 wid250"><input type="text" class="comm__textarea wid100" placeholder="병원명을 입력해주세요." v-model="outerTreatmentHospital" /></div>
                  </div>
                  <div class="flex_item ml60">
                    <p class="scommp c_gray2 fwn" style="margin-bottom: 6px">
                      검진일
                      <span class="c_red">*</span>
                    </p>
                    <date v-model="outerTreatmentDate" :data="outerTreatmentDate" ulsanCheckupReason="true" />
                  </div>
                </div>

                <div v-else-if="selectedOption.length" class="d_block textbox mt10 ml5">
                  <textarea
                    v-model="reason"
                    cols="30"
                    rows="10"
                    class="comm__textarea wid100"
                    :placeholder="`${selectedOption} 사유를 작성해주세요. (선택사항)`"
                    style="padding: 6px; height: 70px"
                  ></textarea>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <v-popupconfirm message="저장" :data-object="dataObject" @save="save"></v-popupconfirm>
      </div>
    </div>
  </div>
</template>

<script>
import School from '@/apis/School';
import Date from '@/components/common/Date.vue';
import popupTitle from '@/components/popup/PopupTitle.vue';
import popupConfirm from '@/components/popup/PopupConfirm.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Date,
    'v-popuptitle': popupTitle,
    'v-popupconfirm': popupConfirm,
  },
  props: ['dataObject'],
  data() {
    return {
      reason: '',
      selectedOption: '',
      options: [
        { label: '개별 검진', id: 'C009000001' },
        { label: '미희망', id: 'C009000002' },
        { label: '기타', id: 'C009000003' },
      ],
      outerTreatmentHospital: '',
      outerTreatmentDate: '',
    };
  },
  computed: {
    ...mapGetters('user', ['districtCodeFirst']),
    ...mapGetters('definedCode', ['valueToCode']),

    title() {
      return '미수검 사유';
    },
  },
  created() {
    this.reason = this.dataObject.notificationScreenReason;

    switch (this.dataObject.notificationScreenStatus) {
      case 'C009000001':
        this.selectedOption = '개별 검진';
        this.outerTreatmentHospital = this.dataObject.hospitalName;
        this.outerTreatmentDate = this.dataObject.treatDate;
        break;
      case 'C009000002':
        this.selectedOption = '미희망';
        break;
      case 'C009000003':
        this.selectedOption = '기타';
        break;
      default:
        this.selectedOption = '';
        this.outerTreatmentDate = this.getToday();
    }
  },
  methods: {
    save() {
      if (this.reason?.length > 250) {
        this.$alert('250자까지 작성할 수 있습니다.', '알림', 'warning');
        return false;
      }
      const form = {
        studentId: this.dataObject.studentId,
        businessDivision: this.valueToCode('C0003', this.dataObject.businessDivision),
        notificationScreenStatus: this.options.find(option => option.label === this.selectedOption).id,
        notificationScreenReason: this.selectedOption !== '개별 검진' ? this.reason : undefined,
        outerTreatmentHospital: this.selectedOption === '개별 검진' ? this.outerTreatmentHospital : undefined,
        outerTreatmentDate: this.selectedOption === '개별 검진' ? this.outerTreatmentDate.split('-').join('') : undefined,
      };
      School.notScreenRegist(form).then(res => {
        if (res && res.data.rt === 200) {
          this.$alert('저장되었습니다.', '알림', 'success').then(() => {
            this.$store.commit('update');
            this.$store.dispatch('popup/popupClose');
          });
        } else {
          alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ' + res.data.rt);
        }
      });
    },
    checked(optionVal, itemVal) {
      return itemVal === optionVal;
    },
    getToday() {
      const date = new window.Date();
      const yyyy = date.getFullYear();
      let dd = date.getDate();
      let mm = date.getMonth() + 1; // January is 0
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      const today = yyyy + '-' + mm + '-' + dd;
      return today;
    },
  },
};
</script>
